import { render, staticRenderFns } from "./KothonTransaction.vue?vue&type=template&id=72beb1da&scoped=true"
import script from "./KothonTransaction.vue?vue&type=script&lang=js"
export * from "./KothonTransaction.vue?vue&type=script&lang=js"
import style0 from "./KothonTransaction.vue?vue&type=style&index=0&id=72beb1da&prod&lang=scss"
import style1 from "./KothonTransaction.vue?vue&type=style&index=1&id=72beb1da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72beb1da",
  null
  
)

export default component.exports